import React, { memo } from 'react';
import { Collapse, Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'i18n';
import { formatPrice } from 'utils/format';
import LeaderMenuItem from 'components/common/LeaderMenuItem';

interface IProps {
  itemType: 'ticket' | 'addon';
  currency: string;
  expanded: boolean;
  totalCount: number;
  totalPrice: number;
  orderEntities: any[];
  orderCounts: Record<string, number>;
}

const useStyles = makeStyles()(() => ({
  wordBreak: {
    wordBreak: 'break-word',
  },
}));

const OrderSummaryItems: React.FC<React.PropsWithChildren<IProps>> = ({
  itemType,
  currency,
  expanded,
  totalCount,
  totalPrice,
  orderEntities,
  orderCounts,
}) => {
  const { classes } = useStyles();
  const [t] = useTranslation('public');
  return (
    <div>
      {expanded ? (
        <Typography variant="subtitle1" paragraph>
          {t<string>('common:general.orderItem', { context: itemType, count: totalCount })}
        </Typography>
      ) : (
        <LeaderMenuItem>
          <Typography variant="subtitle2" fontWeight={500}>
            {t<string>('common:general.orderItemCounter', { context: itemType, count: totalCount })}
          </Typography>
          <Typography variant="subtitle2" fontWeight={500}>
            {formatPrice(totalPrice, currency, true, true)}
          </Typography>
        </LeaderMenuItem>
      )}
      <Collapse in={expanded}>
        <Grid container direction="column" spacing={1}>
          {orderEntities.map(({ id, title, price }) => {
            const count = orderCounts[id];
            return (
              count > 0 && (
                <Grid key={String(id)} item container direction="column" spacing={1} className={classes.wordBreak}>
                  <Grid item>
                    <Typography variant="body1">{title}</Typography>
                  </Grid>
                  <Grid item>
                    <LeaderMenuItem>
                      <Typography variant="caption">
                        {t<string>('common:general.qty')} {count}
                      </Typography>
                      <Typography variant="body1">{formatPrice(price * count, currency, true, true)}</Typography>
                    </LeaderMenuItem>
                  </Grid>
                </Grid>
              )
            );
          })}
        </Grid>
      </Collapse>
    </div>
  );
};

export default memo(OrderSummaryItems);
